// Theme constant
export const drawerWidth = 260;
